import { Label } from "@/components/ui/label";
import { normalizeUrl } from "@/lib/utils";
import type { ServiceDetail } from "@/model/serviceDetails";
import { ExternalLink, Mail, Phone } from "lucide-react";

const Service = (service: ServiceDetail) => {
  return (
    <div className="min-w-68 m-x-4 flex min-h-60 w-full flex-col items-center justify-between gap-5 rounded border bg-white p-4 text-center shadow-sm">
      <div className="flex size-full flex-col items-center justify-center gap-3">
        <Label className="text-[.875rem] font-semibold">
          {service?.serviceName?.toUpperCase()}
        </Label>

        <div className="flex h-12 w-28 items-center justify-center">
          <img
            src={`data:image/png;base64,${service?.image}`}
            alt={service?.serviceName}
            className="size-full object-contain"
          />
        </div>

        <Label className="text-center text-[.875rem] font-semibold text-gray-600">
          {service?.serviceProvider}
        </Label>

        <div className="flex w-full flex-col items-start gap-2 text-[10px] sm:items-center lg:items-start">
          {service?.serviceProviderPhone ? (
            <div className="flex items-center justify-center gap-1.5">
              <div className="flex items-center gap-1.5 text-sm font-medium text-gray-600">
                <Phone size={10} />
                <span>Phone: </span>
              </div>
              <Label className="text-center text-gray-600">
                {service?.serviceProviderPhone}
              </Label>
            </div>
          ) : null}

          {service?.serviceProviderEmail ? (
            <div className="flex w-full items-start gap-1 text-gray-600">
              <div className="flex items-center gap-1.5">
                <Mail size={10} />
                <span className="text-sm font-medium">Email: </span>
              </div>

              <a
                href={`mailto:${service?.serviceProviderEmail}`}
                title={service?.displayEmail || service?.serviceProviderEmail}
                className="min-w-0 truncate text-sm font-medium text-primary no-underline hover:underline"
              >
                {service?.displayEmail || service?.serviceProviderEmail}
              </a>
            </div>
          ) : null}

          {service?.serviceProviderWebsite ? (
            <Label className="flex w-full items-start gap-1 text-gray-600">
              <div className="flex items-center gap-1.5">
                <ExternalLink size={10} className="text-gray-600" />
                <span>Website: </span>
              </div>
              <a
                href={`${normalizeUrl(service?.serviceProviderWebsite)}`}
                target="_blank"
                title={service?.displayWebsite || "Click Here"}
                className="min-w-0 truncate text-primary no-underline hover:underline"
                rel="noreferrer"
              >
                {service?.displayWebsite || "Click Here"}
              </a>
            </Label>
          ) : null}
        </div>
      </div>
      {service?.serviceProviderPhone && (
        <a
          href={`tel:${service?.serviceProviderPhone}`}
          className="flex min-w-40 items-center justify-center rounded bg-primary py-2 text-sm text-white no-underline hover:bg-primary-selected"
        >
          <Phone className="mr-2" size={12} />
          <span>Call Now</span>
        </a>
      )}
    </div>
  );
};

export default Service;
